import React, { useEffect, useState } from 'react';
import { MapFactProps, MapFact } from '../map-fact';
import { useDelayedBoolean } from '../../hooks/use-delayed-boolean';
import { useMatchMedia } from '../../hooks/use-match-media';
import breakpoints from '../../sass-utils/breakpoints.module.scss';
import { useRandomItem } from '../../hooks/use-random-item';

interface Props {
  data: MapFactProps[];
  delay?: number;
}

/** Cycles through mapfacts (desktop), shows a random fact inside the panel on mobile */
export const FactGroup: React.FC<Props> = ({ data, delay }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const isVisible = useDelayedBoolean({ delay: 500 });
  const isDesktop = useMatchMedia(`(min-width: ${breakpoints.medium})`);

  // Mobile only, get a random item to display
  const fact = useRandomItem(data);

  useEffect(() => {
    if (!isDesktop) {
      return;
    }

    const update = () => {
      if (activeIndex >= data.length - 1) {
        setActiveIndex(0);
      } else {
        setActiveIndex(activeIndex + 1);
      }
    };

    const timer = setInterval(() => {
      update();
    }, delay);

    return () => {
      clearInterval(timer);
    };
  }, [activeIndex, data.length, delay, isDesktop]);

  if (isDesktop) {
    return (
      <>
        {data.map((item, index) => (
          <MapFact {...item} key={index} visible={activeIndex === index && isVisible} />
        ))}
      </>
    );
  }

  return <MapFact {...fact} />;
};

FactGroup.defaultProps = {
  delay: 15000,
};
